module.exports = __webpack_public_path__ + "img/link.a721260c.svg";